/* ============================= */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import { HackerFragmentFragmentDoc } from "../../shared/contexts/HackerContext/graphql/hackerFragment.generated";
import { HackerFragmentFragment } from "../../shared/contexts/HackerContext/graphql/hackerFragment.generated";
import * as Types from "../types.generated";
export type GetFavoritedHackersQueryVariables = Types.Exact<{
  favoritedHackerIds?: Types.Maybe<Array<Types.Scalars["Int"]>>;
}>;

export type GetFavoritedHackersQuery = { __typename?: "Query" } & {
  claims: Array<{ __typename?: "Claim" } & HackerFragmentFragment>;
};

export const GetFavoritedHackersDocument = gql`
  query GetFavoritedHackers($favoritedHackerIds: [Int!]) {
    claims(
      where: {
        pipeline: { is: { slug: { equals: "hackthenorth2020-applications" } } }
        id: { in: $favoritedHackerIds }
      }
    ) {
      ...hackerFragment
    }
  }
  ${HackerFragmentFragmentDoc}
`;

/**
 * __useGetFavoritedHackersQuery__
 *
 * To run a query within a React component, call `useGetFavoritedHackersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritedHackersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritedHackersQuery({
 *   variables: {
 *      favoritedHackerIds: // value for 'favoritedHackerIds'
 *   },
 * });
 */
export function useGetFavoritedHackersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetFavoritedHackersQuery,
    GetFavoritedHackersQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetFavoritedHackersQuery,
    GetFavoritedHackersQueryVariables
  >(GetFavoritedHackersDocument, baseOptions);
}
export function useGetFavoritedHackersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFavoritedHackersQuery,
    GetFavoritedHackersQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetFavoritedHackersQuery,
    GetFavoritedHackersQueryVariables
  >(GetFavoritedHackersDocument, baseOptions);
}
export type GetFavoritedHackersQueryHookResult = ReturnType<
  typeof useGetFavoritedHackersQuery
>;
export type GetFavoritedHackersLazyQueryHookResult = ReturnType<
  typeof useGetFavoritedHackersLazyQuery
>;
export type GetFavoritedHackersQueryResult = ApolloReactCommon.QueryResult<
  GetFavoritedHackersQuery,
  GetFavoritedHackersQueryVariables
>;
